import React from 'react';
import styled, { css } from 'styled-components';
import { fontEdenred, fontUbuntuLight } from '../../utilities/utilities';

const ProgressStepWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const ProgressStepItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0.2rem;
  border-radius: 50%;
  border: 2px solid #e6e6e6;
`;

const ProgressStepItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: center;
  height: 2rem;
  width: 2rem;
  color: ${props => props.steps.stepTextColor };
  background-color: ${props => props.steps.stepBackgroundColor };
  border: 2px solid ${props => props.steps.stepBorderColor };
  border-radius: 50%;
  font-size: 1.25rem;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontEdenred};

  ${props => props.active && css`
    color: ${props => props.steps.stepActiveTextColor};
    background-color: ${props => props.steps.stepActiveBackgroundColor};
    border: 2px solid ${props => props.steps.stepActiveBorderColor};
  `};
`;

const Spacer = styled.div`
  width: 1.5rem;
  height: 2px;
  background-color: #e6e6e6;
`;


const ProgressStep = (props) => {
  return (
    <ProgressStepWrapper>
      <ProgressStepItemWrapper>
        <ProgressStepItem active={props.active} steps={props.steps}>{props.step}</ProgressStepItem>
      </ProgressStepItemWrapper>
      {props.allowSpacer ? <Spacer /> : null}
    </ProgressStepWrapper>
  )
};

export default ProgressStep;


// WEBPACK FOOTER //
// ./src/components/ProgressSteps/ProgressStep.js